import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, Card, Button, message } from 'antd';
import { withRouter } from 'react-router-dom';
import './PasswordResetForm.less';
import { PASSWORD_RESET_ERROR, PASSWORD_RESET_SUCCESS } from './../../../actions/PasswordReset';

const FormItem = Form.Item;

class PasswordResetForm extends React.Component {
  constructor() {
    super();
    this.state = {
      error: '',
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case PASSWORD_RESET_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      case PASSWORD_RESET_SUCCESS:
        message.success('Password opdateret!');
        this.props.history.push('/login');
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Compares confirm password of edit and create window to first password.
   * @param rule of the field
   * @param value is the value of the field
   * @param callback is weather the validation fails or not.
   */
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  /**
   * Validates first password of edit and create window to confirm password.
   * @param rule of the field
   * @param value is the value of the field
   * @param callback is weather the validation fails or not.
   */
  validateToNextPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  /**
   * Tells weather or not the passwords are identical
   * @param e is the object that is interacted with
   * @param component is the form where the object clicked came from.
   */
  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (evt) => {
    evt.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const { password, confirmPassword } = values;
      const { id } = this.props;

      if (!password) {
        return this.setState({ error: 'Password feltet er ikke udfyldt' });
      }

      if (!confirmPassword) {
        return this.setState({ error: 'Passwordet er ikke bekræftet' });
      }

      this.setState({ error: '' });
      this.props.passwordReset({ id, password, confirmPassword });
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Card loading={this.props.privilegeCheckLoading} className={'password-reset-form'}>
        {this.props.hasPasswordChangePrivilege ? (
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label={'Password'}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Password skal udfyldes.',
                  },
                  {
                    validator: this.validateToNextPassword,
                  },
                ],
              })(<Input type={'password'} />)}
            </FormItem>
            <FormItem {...formItemLayout} label={'Bekræft Password'}>
              {getFieldDecorator('confirmPassword', {
                rules: [
                  {
                    required: true,
                    message: 'Bekræft password skal udfyldes.',
                  },
                  {
                    validator: this.compareToFirstPassword,
                  },
                ],
              })(<Input type={'password'} onBlur={this.handleConfirmBlur} />)}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              <Button type={'primary'} htmlType={'submit'}>
                Opdater password
              </Button>
            </FormItem>
          </Form>
        ) : (
          <div>Error</div>
        )}
      </Card>
    );
  }
}

export default withRouter(Form.create()(PasswordResetForm));
